import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-10 items-center gap-2 mb-10 select-none"
}
const _hoisted_2 = { class: "text-center my-2" }
const _hoisted_3 = { class: "!font-bold" }
const _hoisted_4 = { class: "text-[10px] xl:text-[12px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.color)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.generateShades(_ctx.color)).reverse(), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("p", {
              class: _normalizeClass(['border w-fit h-fit p-5 xl:p-11']),
              style: _normalizeStyle({ background: item })
            }, null, 4),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(Object.keys(_ctx.generateShades(_ctx.color)).reverse()[index]), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item), 1)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}